import BaseService from "./BaseService";
import { RestApiResponse } from "./RestApi";
import { BaseResponseAttributes } from "../attributes/base-attributes";

export class RaffleDrawService extends BaseService {
  static getRaffleDrawWinners(
    raffleDrawId: number
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return RaffleDrawService.getPublicApiClient().get(
      `raffle-draw/${raffleDrawId}/winners`
    );
  }

  static getAllRaffleDrawsWinners(): Promise<
    RestApiResponse<BaseResponseAttributes>
  > {
    return RaffleDrawService.getPublicApiClient().get(
      `raffle-draw/all-winners`
    );
  }

  static importPhoneNumbers(
    data: any[]
  ): Promise<RestApiResponse<BaseResponseAttributes>> {
    return RaffleDrawService.getApiClient().post(
      `admin/raffle-draws/import-phone-numbers`,
      data
    );
  }
}

export default RaffleDrawService;
